<!-- src/components/lobby/FastGamesSidebar.vue -->
<template>
  <div id="sideMenuBar" class="side-menu-content" :class="{ active: app.sideMenuOpen }">
    <div class="sidebar-content">
      <div class="modal-header" @click="app.closeSideMenu()">
        <div class="modal-title logo">
          <img :src="images.logo" alt="Mossbets" />
          <button type="button" class="close" @click.stop="app.closeSideMenu()">
            <span aria-hidden="true"><i class="bi bi-x"></i></span>
          </button>
        </div>
      </div>

      <div class="sidenav-content">
        <div id="popularFastGames" class="accounts-card">
          <div class="card-header">Popular Games</div>

          <span class="menulink">
            <RouterLink to="/live-games">
              <span class="linkicon"><i class="fi fi-sr-live-alt"></i></span>
              <span class="linktext">Live</span>
            </RouterLink>
          </span>

          <span class="menulink">
            <RouterLink :to="{ name: 'virtual-lobby' }">
              <span class="linkicon"><i class="fi fi-sr-circle-v"></i></span>
              <span class="linktext">Virtual Games</span>
            </RouterLink>
          </span>

          <span class="menulink">
            <RouterLink :to="{ name: 'instant-games' }">
              <span class="linkicon"><i class="fi fi-sr-bolt"></i></span>
              <span class="linktext">Instant Games</span>
            </RouterLink>
          </span>

          <span class="menulink">
            <RouterLink :to="{ name: 'casino-games' }">
              <span class="linkicon"><i class="fi fi-sr-club"></i></span>
              <span class="linktext">Casino Games</span>
            </RouterLink>
          </span>

          <span class="menulink">
            <a href="#!">
              <span class="linkicon"><i class="fi fi-sr-slot-machine"></i></span>
              <span class="linktext">slot</span>
            </a>
          </span>

          <span class="menulink">
            <a href="#!">
              <span class="linkicon"><i class="fi fi-br-roulette"></i></span>
              <span class="linktext">roulette Games</span>
            </a>
          </span>

          <span class="menulink">
            <RouterLink :to="{ name: 'crash-games' }">
              <span class="linkicon"><i class="fi fi-sr-dice-alt"></i></span>
              <span class="linktext">Crash games</span>
            </RouterLink>
          </span>
        </div>

        <!-- MyAccount etc … unchanged from your version -->
        <div id="MyAccount" class="accounts-card">
          <div class="card-header">My Account</div>

          <span class="menulink" v-if="authStore.isAuthenticated">
            <RouterLink to="/my-account">
              <span class="linkicon"><i class="fi fi-rr-user"></i></span>
              <span class="linktext">Profile</span>
            </RouterLink>
          </span>

          <span class="menulink" v-if="authStore.isAuthenticated">
            <RouterLink to="/deposit">
              <span class="linkicon"><i class="fi fi-rr-wallet"></i></span>
              <span class="linktext">Deposit</span>
            </RouterLink>
          </span>

          <span class="menulink" v-if="authStore.isAuthenticated">
            <RouterLink to="/withdraw">
              <span class="linkicon"><i class="fi fi-rr-wallet-arrow"></i></span>
              <span class="linktext">Withdraw</span>
            </RouterLink>
          </span>

          <span class="menulink">
            <router-link :to="{ name: 'promotion' }">
              <span class="linkicon"><i class="fi fi-rr-gift"></i></span>
              <span class="linktext">promotions</span>
            </router-link>
          </span>

          <span class="menulink" v-if="authStore.isAuthenticated">
            <a href="#!">
              <span class="linkicon"><i class="fi fi-rs-badge-percent"></i></span>
              <span class="linktext">freebets</span>
            </a>
          </span>

          <span class="menulink">
            <a href="#!">
              <span class="linkicon"><i class="fi fi-rr-interrogation"></i></span>
              <span class="linktext">Help Center</span>
            </a>
          </span>
        </div>

        <div id="freeData" class="accounts-card">
          <div class="freedata">
            <span class="toggle-btn">
              <label class="switch">
                <input type="checkbox" checked />
                <span class="slider round"></span>
              </label>
              Enable Free Data
              <span class="spec-icon offer">New</span>
            </span>
            <span class="float-right search-game-options"><i class="bi bi-chevron-right"></i></span>
          </div>
        </div>

        <div id="switchTheme" class="accounts-card">
          <div id="toggleTheme" @click="toggleTheme" style="cursor: pointer">
            Switch Mode
            <div class="modeswitch">
              <i
                class="dark-theme fi fi-sr-brightness"
                :style="{ display: isDarkMode ? 'inline' : 'none', color: '#ffc107' }"
              ></i>
              <i
                class="light-theme fi fi-sr-moon-stars"
                :style="{ display: isDarkMode ? 'none' : 'inline' }"
              ></i>
            </div>
          </div>
        </div>

        <div id="sideBaradbanner">
          <div class="sidebar__ads">
            <img :src="images.adsBanner" alt="Ads" />
          </div>
        </div>

        <div id="logOut" class="accounts-card logout" v-if="authStore.isAuthenticated">
          <a href="#" @click.prevent="handleLogout" style="text-decoration: none; color: inherit">
            <span class="account-icon"><i class="fi fi-rr-sign-out-alt"></i> Logout</span>
            <span class="float-right search-game-options"><i class="bi bi-chevron-right"></i></span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { RouterLink, useRouter } from 'vue-router'
import { LOGOS } from '@/constants/media'
import { useAppStore } from '@/stores/app'
import { useAuthStore } from '@/stores/auth'

const app = useAppStore()
const authStore = useAuthStore()
const router = useRouter()
const images = { logo: LOGOS.mossbets, adsBanner: LOGOS.adsBanner }
const isDarkMode = ref(false)

// Logout functionality
function handleLogout() {
  authStore.logout()
  router.push('/')
}

// Theme switching functionality
function toggleTheme() {
  isDarkMode.value = !isDarkMode.value
  const body = document.body

  if (isDarkMode.value) {
    body.classList.add('dark-mode')
    localStorage.setItem('theme', 'dark')
  } else {
    body.classList.remove('dark-mode')
    localStorage.setItem('theme', 'light')
  }
}

// Initialize theme on component mount
onMounted(() => {
  const savedTheme = localStorage.getItem('theme')
  isDarkMode.value = savedTheme === 'dark'

  if (isDarkMode.value) {
    document.body.classList.add('dark-mode')
  }
})
</script>
